import React from "react";
import { FiltersPanel } from "./FiltersPanel";

/**
 * Mobile presentation: the same panel in flow, pushing the roster down.
 *
 * A popover would be wrong on a phone — there is no room beside the trigger and
 * a floating layer over a full-screen sheet reads as a second modal. No Done
 * button either: the tray closes by re-tapping Filters, matching the design.
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Object} props.panelProps - Forwarded to FiltersPanel.
 */
export function FiltersTray({ open, panelProps }) {
  return (
    <div
      // grid-rows 0fr → 1fr animates height without measuring the content,
      // which a filter list of changing length would otherwise need.
      className={`grid overflow-hidden border-t border-[#F1EEEE] bg-[#FBFBFB] transition-[grid-template-rows,opacity] duration-200 motion-reduce:transition-none ${
        // `invisible` alongside aria-hidden is load-bearing: a zero-height grid
        // row still leaves its buttons in the tab order, so a closed tray would
        // otherwise trap keyboard users in six chips they cannot see.
        open ? "grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"
      }`}
      aria-hidden={!open}
    >
      <div className="min-h-0 overflow-hidden pb-1">
        <FiltersPanel {...panelProps} showSortNote={false} />
      </div>
    </div>
  );
}

export default FiltersTray;
